import React  from "react";
import {useEffect,useState }  from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AxiosInstance from '../../../services/AxiosInstance';
import {USER_ROLES_BY_ROLE_URL, USERS_URL, USER_ROLES_URL} from '../../../Constants/Constants';
import Box from '@mui/material/Box';
import { useAlert } from "./../../alerts/AlertContext";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Grid from '@mui/material/Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Container from 'react-bootstrap/Container';
import Paper from '@mui/material/Paper';
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';

function AddUsersToRoleDialog({roleId, selectedRoleName, callRoles}){

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

    const [open, setOpen] = React.useState(false);
    const [roleName, setRoleName] = useState("");
    
    const [users, setUsers] = useState([]);
    const [userRoles, setUserRoles] = useState([]);

    const showAlert = useAlert();
    const [selectedOption, setSelectedOption] = useState(null);
        
    const [userRole, setUserRole] = useState({
        
        roleId: {},
        userIds: []        
      });

    useEffect(() => {        
        getUsers();
        getUserRoles();
    }, []);
    
    const handleClickOpen = async() => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleRoleNameChange = (event) => {
        setRoleName(event.target.value);
    }

    
    const getUsers = () => {
        AxiosInstance.get(USERS_URL).then(response => setUsers(response.data.data));      
    }    

    const handleChange = (event, value) => {
        const userIds = value.map(user => user.id);
        setSelectedOption(userIds);
        console.log('Selected option:', value);
      };

    const addUserRoles = async () => {
        
        userRole.roleId = roleId;
        userRole.userIds = selectedOption;
        
        await AxiosInstance.post(USER_ROLES_URL, userRole)
        .then((response) => {      
            
            if (response.data){
                getUserRoles();
                showAlert("Add Role to Users done successfully!","success");
            }                
            else
                showAlert("Failed Add Role to Users!", "error");
        })
        .catch((error)=>{
            showAlert("Failed Add Role to Users!", "error");
            console.error(error);
        });
        
      };

    const [page, setPage] = React.useState(0);    
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [search, setSearch] = useState("");

    // Filter users based on search input
    // const filteredUsers = userRoles.filter(userRole =>
    //     userRole.user.name.toLowerCase().includes(search.toLowerCase()) ||
    //     userRole.role.name.toLowerCase().includes(search.toLowerCase())
    // );

    const filteredUsers = React.useMemo(() => {
        return userRoles.filter(userRole =>
            userRole.user.name.toLowerCase().includes(search.toLowerCase()) ||
            userRole.role.name.toLowerCase().includes(search.toLowerCase())
        );
      }, [search]);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
        
    const handleDeleteUserRole = (usrRole) => {
        
        AxiosInstance.post(USER_ROLES_URL + usrRole).then(response => showAlert("Removed ticket  successfully!", "success")); 
        
        setUserRoles((uRoles) => uRoles.filter((item) => item.id !== usrRole));
        
    };   

    const getUserRoles = () => {
        
        AxiosInstance.get(USER_ROLES_BY_ROLE_URL + roleId).then(response => setUserRoles(response.data)); 
        
    };   


    const displayRows = React.useMemo(
        () =>
          [...userRoles]            
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
        [userRoles, page, rowsPerPage],
      );

    // const displayRows = React.useMemo(() => {
    //     return filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //   }, [filteredUsers, page, rowsPerPage]);


    return(
        <React.Fragment>
                
                <GroupAddIcon style={{cursor:"pointer"}} onClick={handleClickOpen}/>
                
                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();                        
                        //saveRole();                    
                        handleClose();
                    },
                    }}
                >
                    <DialogTitle>{'Assign Role'}</DialogTitle>
                    <DialogContent>
                        <Box
                            component="form"                        
                            sx={{ '& .MuiTextField-root': { m: 1, width: '50ch' } }}
                            noValidate
                            autoComplete="off"
                        >

                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="rg"
                                name="name"
                                label="Role Name"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={selectedRoleName}
                                disabled
                                onChange={handleRoleNameChange}                    
                            />
                            <Grid container spacing={2} columns={16}>
                            <Grid size={13}>                
                            <Autocomplete
                                multiple
                                limitTags={2}
                                id="checkboxes-tags-demo"
                                size="small"                    
                                options={users}
                                onChange={handleChange}
                                disableCloseOnSelect
                                getOptionLabel={(option) => option.name}
                                renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option.name}
                                    </li>
                                );
                                }}
                                style={{ width: "100%" }}
                                renderInput={(params) => (
                                <TextField {...params} label="Users" placeholder="Users" />
                                )}
                            />
                            </Grid>
                            <Grid size={3}>
                                <Button variant="contained" color="primary" style={{marginTop:"7px"}} onClick={addUserRoles}>
                                    Add
                                </Button>

                            </Grid>
                        </Grid>
                        {displayRows.length > 0 ? (
                        <Container fluid>      
                        
                            <Box sx={{ width: '100%' }}>
                            <Paper sx={{ width: '100%', mb: 2 }}>
                            {/* <TextField
                                label="Search"
                                variant="outlined"
                                fullWidth
                                margin="dense"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            /> */}
                            <TableContainer component={Paper} >
                                <Table sx={{ tableLayout: "fixed", width: "100%" }} aria-label="customized table">
                                    <TableHead>
                                    <TableRow>
                                        {/* <StyledTableCell>Id</StyledTableCell> */}
                                        <StyledTableCell>Name</StyledTableCell>
                                        <StyledTableCell>Role</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {displayRows.map((userRole, index) => {                
                                    return (                    
                                            <StyledTableRow>
                                            {/* <StyledTableCell>{userRole.id}</StyledTableCell> */}
                                            
                                            {/* <StyledTableCell>{userRole.user.name}</StyledTableCell>
                                            <StyledTableCell>{userRole.role.name}</StyledTableCell> */}
                                            
                                            <StyledTableCell>{userRole.userName}</StyledTableCell>
                                            <StyledTableCell>{userRole.roleName}</StyledTableCell>

                                            <StyledTableCell>
                                                <IconButton edge="end" onClick={() => handleDeleteUserRole(userRole.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </StyledTableCell>

                                            </StyledTableRow>
                                            )
                                        })}
                                    
                                    </TableBody>
                                </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={userRoles.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                    </Paper>
                                </Box>                
                        </Container>
                        ) : (
                            <p>No data available</p> 
                          )}
                        </Box>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button type="submit">Add </Button> */}
                    </DialogActions>
                </Dialog>
                </React.Fragment>
    )
}
export default AddUsersToRoleDialog;